export default {
  LOCAL: "local", // ローカル環境
  DEVELOPMENT: "dev", // 開発環境
  STAGING: "stg", // ステージング環境
  PRODUCTION: "prod" // 本番環境
};
